import {Localize} from "@dp-instant/i18n";
import {CancelButton} from "@game/ui/components/CancelButton/CancelButton";
import {ConfirmButton} from "@game/ui/components/ConfirmButton/ConfirmButton";
import {UIConstants} from "@game/ui/constants";
import cn from "classnames";
import {CrossPromo, visibilityEffect} from "@dp-instant/ui";
import "./ConfirmPopup.less";

type ConfirmPopupProps = {
    onConfirm: (confirmed?: boolean) => void;
};

export const ConfirmPopup = ({onConfirm}: ConfirmPopupProps) => {
    const [invisible] = visibilityEffect(UIConstants.popup.startDelay);
    return (
        <div className="popups">
            <div className={cn("popup-confirm")}>
                <div className={cn("popup", {invisible})}>
                    <div className="popup__title">{Localize.get("ui-exit-exit_label", "EXIT")}</div>
                    <div className="popup__body">
                        <div>{Localize.get("ui-exit-description", "Leave the game?")}</div>
                    </div>
                    <div className={"popup__body-buttons"}>
                        <div className={cn("popup__body-button", "left")}>
                            <div>
                                <ConfirmButton onClick={() => onConfirm(true)} />
                            </div>
                        </div>
                        <div className={cn("popup__body-button", "right")}>
                            <div>
                                <CancelButton onClick={() => onConfirm(false)} />
                            </div>
                        </div>
                    </div>
                </div>
                <CrossPromo delay={UIConstants.popup.startDelay + 100} />
            </div>
        </div>
    );
};
